/**
 * Pure currency helpers (framework-agnostic, no React).
 */

/**
 * Whether ``value`` carries a non-zero fractional part, for *any*
 * currency (``"1200.50"`` → ``true``; ``"1200"`` / ``"1200.00"`` /
 * ``""`` / non-numeric → ``false``).
 *
 * Billing precision is whole major units everywhere, so the server
 * rounds a cents-bearing price or fixed discount on save. This drives a
 * non-blocking "cents will be rounded" *warning* — never a hard block:
 * the value is still accepted and submitted.
 */
export function hasFractionalUnits(value: string): boolean {
  const numeric = Number(value)
  return Number.isFinite(numeric) && !Number.isInteger(numeric)
}

/**
 * Round a money string to the nearest whole major unit (half-up),
 * mirroring the server's ``round_money``. Returns ``null`` for a
 * non-numeric value so callers can skip the rounded preview. ``Math``
 * rounds .5 up for the non-negative amounts these forms accept.
 */
export function roundMoneyPreview(value: string): number | null {
  const numeric = Number(value)
  return Number.isFinite(numeric) ? Math.round(numeric) : null
}
